import React from "react";
import Select from "components/shared/Select";
import InputTextCounter from "components/shared/InputTextCounter";

const InContentAskAiFormFields = ({
  formik,
  loading,
  disableFields,
  locked,
  amplitudeKey,
  isSignedOut,
  questionMinimum,
  options,
  storeFieldForReload,
  storeTitleOptionForReload,
  onResourceChange
}) => {
  const handleTitleChange = (e) => {
    storeFieldForReload("title", e.value);
    storeTitleOptionForReload(e.label, e.value, e.title);
    formik.setFieldValue("title", e.value);
    onResourceChange(e);
  };

  const handleQuestionChange = (e) => {
    formik.setFieldError("question", null);
    storeFieldForReload("question", e.target.value);
    formik.setFieldValue("question", e.target.value);
  };

  return (
    <div className="ai-form--fields !tw-gap-3">
      <Select
        errorMessage={formik.errors.title}
        id="title"
        isDisabled={loading || disableFields}
        isSearchable
        maxMenuHeight={222}
        menuPlacement="top"
        name="title"
        options={options}
        onChange={handleTitleChange}
        value={formik.values.title}
      />
      <InputTextCounter
        disabled={loading || disableFields}
        locked={locked}
        amplitudeKey={amplitudeKey()}
        inputClass="input-md"
        hideSubtext={disableFields}
        errorMessage={formik.errors.question}
        buttonVariant
        onSubmit={formik.handleSubmit}
        {...(isSignedOut && {
          buttonProps: {
            "data-target": "#ask-ai-free-tier .modal",
            "data-toggle": "modal"
          }
        })}
        name="question"
        min={questionMinimum}
        max={300}
        onChange={handleQuestionChange}
        placeholder={!disableFields ? "Write your question..." : ""}
        value={formik.values.question}
      />
    </div>
  );
};

export default InContentAskAiFormFields;
